import map from "lodash/fp/map";
import moment from "moment";
import constants from "../../core/constants";

class ReportsPageTransform {
  constructor(Lists) {
    "ngInject";

    this.Lists = Lists.all;
    this.captainRatingFields = [
      { name: "dateRange", title: "Date Range" },
      { name: "createdAt", title: "Creation Date" },
      { name: "type", title: "Type" },
    ];
  }

  justifyCaptainRating(data) {
    const format = (item) => {
      const toDate = moment(item.query.toDate).format(constants.dateTimeFormat);
      const fromDate = moment(item.query.fromDate).format(
        constants.dateTimeFormat
      );

      item.dateRange = `from ${fromDate} to ${toDate}`;
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);

      return item;
    };

    return map(format)(data);
  }
}

export default ReportsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/reports/reports.transforms.js